// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/FranchisorChannels_ListResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * FranchisorChannels_ListResponse — GET /franchisor-channels/list.
 *
 * Also reused, with a single-element `rows`, as the response of
 * POST /franchisor-channels/save and POST /franchisor-channels/toggle —
 * both mutate exactly one channel and the console re-renders that one row
 * from fresh DB state (same reuse the S10 console uses for
 * ScheduledJobs_ListResponse).
 */
import type { FranchisorChannels_ChannelRow } from './FranchisorChannels_ChannelRow'
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface FranchisorChannels_ListResponseDados {
rows: FranchisorChannels_ChannelRow[]
}

export type FranchisorChannels_ListResponse = ApiResponse<FranchisorChannels_ListResponseDados>;

registerResponseContract('FranchisorChannels_ListResponse', {
  rows: {
    type: 'array',
    required: true,
    items: {
      id:               { type: 'number',  required: true },
      name:             { type: 'string',  required: false },
      type:             { type: 'string',  required: false },
      provider:         { type: 'string',  required: false },
      api_key:          { type: 'string',  required: false },
      sender:           { type: 'string',  required: false },
      enabled:          { type: 'boolean', required: false },
      enabled_triggers: { type: 'array',   required: false },
      created_at:       { type: 'string',  required: false },
      updated_at:       { type: 'string',  required: false },
    },
  },
})
